import React from 'react';

import classNames from '../../lib/classNames';

type SkeletonProps = {
  className?: string;
};

export default function Skeleton({ className }: SkeletonProps) {
  return (
    <div className={classNames('animate-pulse bg-gray-300 dark:bg-gray-600', className || '')} />
  );
}
